import { Navigate } from 'react-router';

import { SupportedCurrency } from '@sorare/core/src/__generated__/globalTypes';
import {
  MY_SORARE_TRANSACTIONS_CASH,
  MY_SORARE_TRANSACTIONS_CREDITCARD,
  MY_SORARE_TRANSACTIONS_ETH,
  MY_SORARE_TRANSACTIONS_SOL,
} from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useCurrentUserCurrencies } from '@sorare/core/src/hooks/useCurrentUserCurrencies';

const Page = () => {
  const {
    walletPreferences: { showFiatWallet, showCryptoWallet },
  } = useCurrentUserContext();
  const { cryptocurrency } = useCurrentUserCurrencies();
  const initialRoute = (() => {
    if (showCryptoWallet) {
      switch (cryptocurrency) {
        case SupportedCurrency.LAMPORT:
          return MY_SORARE_TRANSACTIONS_SOL;
        case SupportedCurrency.WEI:
        default:
          return MY_SORARE_TRANSACTIONS_ETH;
      }
    }
    if (showFiatWallet) {
      return MY_SORARE_TRANSACTIONS_CASH;
    }
    return MY_SORARE_TRANSACTIONS_CREDITCARD;
  })();

  return <Navigate to={initialRoute} />;
};

export default Page;
